import React from 'react'
import Button from 'shared/Buttons/Button/Button'
import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import { useNavigate } from 'react-router-dom'
import ProtectionTemplatesTable from '../components/ProtectionTable'

type Props = {}

export default function ProtectionTemplatesPage({}: Props) {
  const navigate = useNavigate()

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Шаблоны защит</h2>
          </div>
          <div className='inline-flex-gap'>
            <Button theme='primary' onClick={() => navigate('/admin/protection-templates/create')}>
              <span className='inline-flex-gap' style={{ gap: '0.5em' }}>
                <span>+</span>
                <span>Создать</span>
              </span>
            </Button>
          </div>
        </div>
        <ProtectionTemplatesTable />
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}
